

const liveStatus = [
    {
        name:'Semua',
        value:'active'
    },
    {
        name:'Dikonfirmasi',
        value:'confirmed'
    },
    {
        name:'Teralokasi',
        value:'allocated'
    },
    {
        name:'Menjemput',
        value:'pickingUp'
    },
    {
        name:'Terjemput',
        value:'picked'
    },
    {
        name:'Dalam Pengiriman',
        value:'droppingOff'
    },
    {
        name:'Dalam Pengembalian',
        value:'returnInTransit'
    },
    {
        name:'Ditahan',
        value:'onHold'
    }
]
export default liveStatus